let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hnxy3"), load("4Qclh"), load("dwoYJ"), load("emd3r"), load("18vkH"), load("4CNxJ")]).then(() => parcelRequire('2x2RL'));